module.exports = __webpack_public_path__ + "img/zbtitle.d5e65864.png";